import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  mode: 'view',
}

const spostamentiSlice = createSlice({
  name: 'spostamenti',
  initialState,
  reducers: {
    setSelectedStatus(state, action) {
      state.selectedStatus = action.payload
    },
    setSelectedGroup(state, action) {
      state.selectedGroup = action.payload
    },
  },
})

export const { setSelectedStatus, setSelectedGroup } = spostamentiSlice.actions

export default spostamentiSlice.reducer
